import React from "react";

// Indicador visual de la etapa del servicio en la pantalla del móvil.
// Solo muestra; no cambia ningún estado.
export default function PasosServicio({ estado, recepcionApp }) {
  const esTraslado = estado === "TRASLADO";
  const pasos = [
    "Recepción",
    "Salida",
    "Llegada",
    esTraslado ? "Traslado" : "Cierre",
  ];

  let actual = -1;
  if (estado === "PASADO") actual = recepcionApp ? 1 : 0;
  if (estado === "SALIDA") actual = 2;
  if (estado === "LLEGADA" || esTraslado) actual = 3;
  if (actual === -1) return null;

  return (
    <div className="st-pasos">
      {pasos.map((paso, i) => (
        <div
          key={paso}
          className={
            "st-paso" +
            (i < actual ? " st-paso-hecho" : "") +
            (i === actual ? " st-paso-actual" : "")
          }
        >
          <span className="st-paso-punto">
            {i < actual ? <i className="pi pi-check" /> : i + 1}
          </span>
          <span className="st-paso-texto">{paso}</span>
        </div>
      ))}
    </div>
  );
}
